import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import type { ClaimCounter } from '@recruitee/referrals-types';
import { ReferralsPortalApplicationStatus } from '@recruitee/referrals-types';

@Injectable({ providedIn: 'root' })
export class ClaimCountersHttpClient {
  constructor(private httpApi: HttpApiService) {}

  public loadApplicationsCounters(): Observable<ClaimCounter[]> {
    return this.httpApi.get(`/referral/applications/counters`, {
      status: ReferralsPortalApplicationStatus.Claimed,
    });
  }
}
